// assets/cart-preorder.js
(function () {
  function getEls() {
    return {
      checkbox: document.getElementById('preorder-agreement-checkbox'),
      alert: document.getElementById('alertMessage'),
      checkout: document.getElementById('checkout'),
      dynamicCheckout: document.querySelector(
        '.cart__dynamic-checkout-buttons.additional-checkout-buttons'
      )
    };
  }

  function setButtonDisabled(button, disabled) {
    if (!button) return;
    button.disabled = disabled;

    if (disabled) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('button--disabled');
    } else {
      button.removeAttribute('aria-disabled');
      button.classList.remove('button--disabled');
    }
  }

  // Returns an object with validation info
  function validateCart(els) {
    var hasPreOrderItem = false;
    var hasInStockItem = false;
    var preorderCount = 0;
    var monthKey = null;
    var monthMismatch = false;

    document.querySelectorAll('tr.cart-item').forEach(function (row) {
      var etaEl = row.querySelector('[data-preorder="true"][data-eta-month]');
      if (etaEl) {
        hasPreOrderItem = true;
        preorderCount++;

        var key = etaEl.getAttribute('data-eta-month');
        if (monthKey === null) {
          monthKey = key;
        } else if (key !== monthKey) {
          monthMismatch = true;
        }
      } else {
        hasInStockItem = true;
      }
    });

    var errors = [];

    if (hasPreOrderItem) {
      if (monthMismatch) {
        errors.push('All pre-order items must have the same ETA month.');
      }
      if (preorderCount > 4) {
        errors.push(
          'You can only add four type of Pre Order product with same ETA month in your cart.<br/>Please make a separate order for different type of Pre Order product.'
        );
      }
      if (hasInStockItem) {
        errors.push(
          'Your cart cannot contain pre-order and in stock items at the same time, please place separate orders.'
        );
      }
    }

    return {
      hasPreOrderItem: hasPreOrderItem,
      hasInStockItem: hasInStockItem,
      isValid: errors.length === 0,
      errors: errors
    };
  }

  function bindCheckboxIfNeeded(checkbox) {
    if (!checkbox) return;
    if (checkbox.dataset.preorderBound === 'true') return;

    checkbox.addEventListener('change', updateUI);
    checkbox.addEventListener('input', updateUI);
    checkbox.dataset.preorderBound = 'true';
  }

  function updateUI() {
    var els = getEls();
    var validation = validateCart(els);

    // Update alert messages
    if (els.alert) {
      if (validation.errors.length > 0) {
        els.alert.style.display = 'block';
        els.alert.innerHTML = 'CAUTION:<br/>' + validation.errors.join('<br/>');
      } else {
        els.alert.style.display = 'none';
        els.alert.innerHTML = '';
      }
    }

    // If cart is invalid, disable everything
    if (!validation.isValid) {
      if (els.checkbox) els.checkbox.disabled = true;
      setButtonDisabled(els.checkout, true);
      if (els.dynamicCheckout) els.dynamicCheckout.style.display = 'none';
      return;
    }

    // Cart is valid - require checkbox agreement for all cases
    if (els.checkbox) {
      els.checkbox.disabled = false;
      bindCheckboxIfNeeded(els.checkbox);

      var agreed = !!els.checkbox.checked;
      setButtonDisabled(els.checkout, !agreed);

      if (els.dynamicCheckout) {
        els.dynamicCheckout.style.display = agreed ? 'block' : 'none';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateUI();

    var form = document.getElementById('cart');
    if (form) {
      form.addEventListener('submit', function (e) {
        var els = getEls();
        var validation = validateCart(els);

        // Block if invalid
        if (!validation.isValid) {
          e.preventDefault();
          return;
        }

        // Block if checkbox not checked
        if (els.checkbox && !els.checkbox.checked) {
          e.preventDefault();
          if (els.alert) {
            els.alert.innerHTML = 'Please confirm the pre-order policy before checking out.';
            els.alert.style.display = 'block';
          }
        }
      });
    }
  });

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      updateUI();
    });
  }
})();